import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import backend_url from "../../../../routes/API_URL";
import swal from 'sweetalert';

const API_URL = backend_url['api_url'];

class NationalNesPerformanceReport extends Component {
  constructor(props) {
    super(props);
    
    // Get school_id from props (passed from parent)
    const school_id = props.school_id || window.sessionStorage.getItem("school_id");
    console.log('NationalNesPerformanceReport - school_id:', school_id);
    
    this.state = {
      GraphicalData: [],
      school_id: school_id,
      bearer_auth: window.sessionStorage.getItem('token'),
      loading: true,
      error: null,
      chartOptions: {
        chart: {
          type: 'bar',
          height: 290,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
          }
        },
        colors: ['#FF8C00'],
        plotOptions: {
          bar: {
            columnWidth: '45%',
            dataLabels: {
              show: true
            }
          }
        },
        legend: { show: true },
        dataLabels: { enabled: false },
        grid: {
          borderColor: '#f8f8fa',
          row: { colors: ['transparent', 'transparent'] }
        },
        stroke: {
          show: true,
          width: 1.5,
          colors: ['#fff']
        },
        xaxis: {
          categories: [],
          axisBorder: { show: false },
          axisTicks: { show: false },
          title: { text: 'National Educational Standards' },
          labels: {
            rotate: -45,
            trim: true,
            maxHeight: 120
          }
        },
        yaxis: {
          title: { text: 'AVERAGE ACHIEVEMENT COUNT' },
          min: 0,
          max: 4,
          tickAmount: 4
        },
        noData: {
          text: 'Loading data...',
          align: 'center',
          verticalAlign: 'middle'
        }
      },
      series: [{ name: 'Average Achievement Count', data: [] }]
    };
  }
  
  componentDidMount() {
    this.fetchData();
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.school_id !== prevProps.school_id) {
      this.setState({ school_id: this.props.school_id }, () => {
        this.fetchData();
      });
    }
  }
  
  fetchData() {
    const { school_id, bearer_auth } = this.state;
    
    if (!school_id || school_id === 'undefined' || school_id === 'null') {
      this.setState({ 
        error: 'No valid school ID',
        loading: false 
      });
      return;
    }
    
    if (!bearer_auth) {
      this.setState({ 
        error: 'No authentication token',
        loading: false 
      });
      return;
    }
    
    this.setState({ loading: true });
    
    axios.get(`${API_URL}/key_evidences/nes_perf/school/${school_id}`, {
      headers: { "Authorization": `Bearer ${bearer_auth}` }
    })
    .then(response => {
      const data = response.data || [];
      this.processData(data);
    })
    .catch(error => {
      console.error('Error loading NES performance data:', error);
      this.setState({ 
        error: 'Failed to load data',
        loading: false 
      });
      
      swal({
        title: "",
        text: "Failed to load school performance data.",
        icon: "error",
        timer: 3000
      });
    });
  }
  
  processData(GraphicalData) {
    if (!GraphicalData || GraphicalData.length === 0) {
      this.setState({
        loading: false,
        error: 'No data available for this school'
      });
      return;
    }
    
    const categories = [];
    const values = [];
    
    for (let i = 0; i < GraphicalData.length; i++) {
      const item = GraphicalData[i];
      if (item && item['NES'] !== undefined && item['ACHIEVEMENT'] !== undefined) {
        categories.push(`NES ${item['NES']}`);
        values.push(parseFloat(item['ACHIEVEMENT']) || 0);
      }
    }
    
    this.setState(prevState => ({
      GraphicalData,
      loading: false,
      chartOptions: {
        ...prevState.chartOptions,
        xaxis: { 
          ...prevState.chartOptions.xaxis, 
          categories: categories 
        }
      },
      series: [{ name: 'Average Achievement Count', data: values }]
    }));
  }
  
  render() {
    const { chartOptions, series, loading, error } = this.state;
    
    if (loading) {
      return <div className="text-center p-3">Loading school data...</div>;
    }
    
    if (error) {
      return <div className="text-center p-3 text-danger">{error}</div>;
    }
    
    if (!series[0].data || series[0].data.length === 0) {
      return <div className="text-center p-3">No performance data available for this school</div>;
    }
    
    return (
      <React.Fragment>
        <ReactApexChart 
          options={chartOptions} 
          series={series} 
          type="bar" 
          height={290} 
        />
      </React.Fragment>
    );
  }
}

export default NationalNesPerformanceReport;